import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AuthMsalService } from '@shared/services/auth-msal.service';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDrawerModule, NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzFormModule } from 'ng-zorro-antd/form';
import { CommonModule } from '@angular/common';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { DrawerFactoryService } from '@shared/services/drawer-factory.service';
import { LayoutService } from '@shared/services/layout.service';
import { UserProfileEditComponent } from './user-profile-edit/user-profile-edit.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { take } from 'rxjs';
import { DerichebourgColorEnum } from '@shared/enums/color-derichebourg-enum';

@Component({
  selector: 'app-user-profile',
  imports: [NzButtonModule, NzDrawerModule, ReactiveFormsModule, NzFormModule, CommonModule, NzCardModule, NzTooltipModule, NzIconModule, NzAvatarModule, TranslateModule],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss'
})
export class UserProfileComponent implements OnInit {
  /**
   * Avatar text to display
   *
   * @public
   * @type {string}
   */
  public avatarText: string = ''

  /**
   * User display name
   *
   * @public
   * @type {string}
   */
  public userDisplayName: string = '';

  /**
   * Sidebar collapsed state
   *
   * @public
   * @type {boolean}
   */
  @Input() public sidebarCollapsed: boolean = false;
  /**
    * Color tooltip
    *
    * @public
    * @type {string}
    */
  public derichebourgColorBlue: string = DerichebourgColorEnum.BLUE;
  /**
   * Drawer close button template
   *
   * @type {!TemplateRef<object>}
   */
  @ViewChild('drawerClose', { static: true }) drawerCloseTpl!: TemplateRef<object>;
  /**
   * Drawer ref 
   *
   * @public
   * @type {?NzDrawerRef<unknown, unknown>}
   */
  public drawerRef?: NzDrawerRef<unknown, unknown>;

  constructor(
    private _authMsalService: AuthMsalService,
    private readonly _drawerFactory: DrawerFactoryService,
    private readonly _layoutService: LayoutService,
    private readonly _translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.displayAvatarProfile();
  }

  /**
 * Open edit drawer on click
 *
 * @public
*/
  public openDrawerUserProfileEditComponent() {
    this.drawerRef = this._drawerFactory.open({
      title: this._translateService.instant('profil.title'),
      component: UserProfileEditComponent,
      componentParams: {},
      extraTemplate: this.drawerCloseTpl,
      width: this._layoutService.getAdaptiveWidth('34rem'),
      placement: 'left'
    });
  }

  /**
 * Close side drawer on click
 *
 * @public
 */
  public closeDrawer(): void {
    this.drawerRef?.close();
  }

  /**
   * Display avatar profile
   *
   * @private
   */
  private displayAvatarProfile(): void {
    this.avatarText = this._authMsalService.generateAvatar();
    this._authMsalService.getCurrentUser()
      .pipe(take(1))
      .subscribe(user => {
        this.userDisplayName = user?.name || 'User';
      });
  }
}
